const $ = jQuery.noConflict();

class Slider {
	constructor(slider, slidesMod, slidesXL, slidesL, slidesM, slidesS, slidesXS, arrows, centerTo, infinite, initialSlide = 0, asNavFor = '', focusOnSelect = false, centerMode = false) {
		this.slider = slider;
		this.slidesMod = slidesMod;
		this.slidesXL = slidesXL;
		this.slidesL = slidesL;
		this.slidesM = slidesM;
		this.slidesS = slidesS;
		this.slidesXS = slidesXS;
		this.arrows = arrows;
		this.centerTo = centerTo;
		this.infinite = infinite;
		this.initialSlide = initialSlide;
		this.asNavFor = asNavFor;
		this.focusOnSelect = focusOnSelect;
		this.centerMode = centerMode;
	}
	setSlider(slider, slidesMod, slidesXL, slidesL, slidesM, slidesS, slidesXS, arrows, centerTo, infinite, initialSlide, asNavFor, focusOnSelect, centerMode) {
		if (centerTo) {
			$(this.slider).on('init', () => {
				const arrowsVar = $(this.slider).find('.slick-arrow');
				const centerToVar = $(this.slider).find(this.centerTo);
				const positionTop = `${Math.ceil(centerToVar.height() / 2)}px`;
				arrowsVar.css('top', positionTop);
			});
		}

		$(this.slider).slick({
			infinite,
			slidesToShow: slidesXL,
			slidesToScroll: 1,
			dots: false,
			arrows,
			initialSlide,
			asNavFor,
			focusOnSelect,
			centerMode,
			centerPadding: '0',
			responsive: [
				{
					breakpoint: 1800,
					settings: {
						slidesToShow: slidesMod,
					},
				},
				{
					breakpoint: 1400,
					settings: {
						slidesToShow: slidesL,
					},
				},
				{
					breakpoint: 1199,
					settings: {
						slidesToShow: slidesM,
					},
				},
				{
					breakpoint: 991,
					settings: {
						slidesToShow: slidesS,
					},
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: slidesXS,
					},
				},
			],
		});
	}
	init() {
		this.setSlider(this.slider, this.slidesMod, this.slidesXL, this.slidesL, this.slidesM, this.slidesS, this.slidesXS, this.arrows, this.centerTo, this.infinite, this.initialSlide, this.asNavFor, this.focusOnSelect, this.centerMode);
	}
}

//const menuSlider = new Slider('.slider-block .slides',5, 5, 4, 3, 2, 1, true, '', true);
const newsSliderTop = new Slider('.image-text-slider .slider-wrapper',3, 4, 3, 2, 1, 1, true, '.img-wrapper', true);
const menuNavSlider = new Slider('.menu-list',7, 7, 6, 5, 4, 2, true, '', false);
const sliderBlockMain = new Slider('.popup-slider__main',1, 1, 1, 1, 1, 1, true, '', true, 0, '.popup-slider__nav');
const sliderBlockNav = new Slider('.popup-slider__nav', 3, 3, 3, 3, 3, 3, false, '', true, 0, '.popup-slider__main', true, false);

//export default menuSlider;
export { newsSliderTop, menuNavSlider, sliderBlockMain, sliderBlockNav };
